(function ($) {
  'use strict';

var FREE_SHIPPING_THRESHOLD_CENTS = 6500; // $65
var FREE_SHIPPING_SAVINGS_CENTS   = 2900;  


  var $doc  = $(document);

  $(document).ajaxStart(function () { $('body').addClass('loading'); });
  $(document).ajaxStop(function () { $('body').removeClass('loading'); });

  function formatMoney(cents) {
    cents = Math.max(0, parseInt(cents || 0, 10));
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, (window.theme && theme.moneyFormat) ? theme.moneyFormat : '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function openDrawer() {
    $('#side-cart').addClass('show-cart__drawer');
    $('body').addClass('cv--show-cart__drawer');
  }

  function closeDrawer() {
    $('#side-cart').removeClass('show-cart__drawer');
    $('body').removeClass('cv--show-cart__drawer');
  }

  function fetchCartJSON() {
    return $.getJSON('/cart.js');
  }

  function initAddonsSwiper() {
    var $c = $('#side-cart .ass_add_onproduct.swiper-container');
    if (!$c.length || typeof Swiper === 'undefined' || $c.data('inited')) return;
    new Swiper('#side-cart .ass_add_onproduct.swiper-container', {
      slidesPerView: 1.5,
      spaceBetween: 8,
      freeMode: true,
      loop: false,
      grabCursor: true,
      navigation: {
        nextEl: '#side-cart .swiper-button-next',
        prevEl: '#side-cart .swiper-button-prev',
      },
      pagination: {
        el: '#side-cart .swiper-pagination',
        type: 'progressbar',
      },
      breakpoints: {
        500: { slidesPerView: 1.8, spaceBetween: 8 }
      }
    });
    $c.data('inited', true);
  }

  // helper: выполнить перерисовку без CSS-анимаций
  function renderWithoutAnimation($el, fn) {
    if (!$el || !$el.length) { if (typeof fn === 'function') fn(); return; }
    $el.css({ transition: 'none', animation: 'none' });
    if (typeof fn === 'function') fn();
    // форсим reflow
    // eslint-disable-next-line no-unused-expressions
    $el[0] && $el[0].offsetHeight;
    setTimeout(function () {
      $el.css({ transition: '', animation: '' });
    }, 0);
  }

  function replaceDrawerFromHTML(fullHTML, keepOpen) {
    var $incoming = $(fullHTML).find('#side-cart');
    if (!$incoming.length) return $.Deferred().reject('No #side-cart in response');

    var $current = $('#side-cart');
    var wasOpen = !!(keepOpen || $current.hasClass('show-cart__drawer'));

    if (wasOpen) {
      // помечаем входящую ноду как открытую заранее
      $incoming.addClass('show-cart__drawer');
    }

    // подмена DOM без анимации
    renderWithoutAnimation($current, function () {
      $current.replaceWith($incoming);
    });

    // инициализация нового содержимого
    initAddonsSwiper();

    // возвращаем состояние body и страхуемся от анимации в этот кадр
    if (wasOpen) {
      $('body').addClass('cv--show-cart__drawer');
      renderWithoutAnimation($('#side-cart'));
    }

    return $.Deferred().resolve();
  }

  function refreshCartUI(keepOpen) {
    var dCart = fetchCartJSON();
    var dHTML = $.get(window.location.href);
    return $.when(dCart, dHTML).done(function (cartResp, htmlResp) {
      var cart = cartResp[0];
      var fullHTML = htmlResp[0];
      replaceDrawerFromHTML(fullHTML, keepOpen);
      updateFreeShippingUI(cart);
      updateSubtotal(cart);
    });
  }

  function updateSubtotal(cart) {
    $('#side-cart').find('.igSubtotal .money').text(formatMoney(cart.items_subtotal_price || cart.total_price));
  }

  function updateFreeShippingUI(cart) {
    var total = parseInt((cart && cart.items_subtotal_price) || 0, 10);
    var threshold = FREE_SHIPPING_THRESHOLD_CENTS;

    var $wrap = $('#side-cart .cart-free-shipping');
    var $bar  = $wrap.find('[data-shipping-bar-line]');
    var $check = $wrap.find('.check.check-full');
    var $msg = $wrap.find('#ship-msg');
    var $msgSavings = $wrap.find('#ship-msg-savings');

    if (!threshold || threshold <= 0) {
      $bar.css({ width: '0%' }); $check.hide(); $msg.text(''); $msgSavings.hide(); return;
    }

    var percent = Math.min(100, Math.floor((total / threshold) * 100));
    var left = Math.max(0, threshold - total);
    $bar.css({ width: percent + '%' });

    if (total >= threshold) {
      $check.show();
      $msg.html('You have unlocked <b>free shipping!</b>');
      $msgSavings.html("You're saving <b>" + formatMoney(FREE_SHIPPING_SAVINGS_CENTS) + "</b> and unlocked <b>free shipping!</b>").show();
      $wrap.removeAttr('data-shipping-false');
    } else {
      $check.hide();
      $msg.html('Spend <b>' + formatMoney(left) + '</b> more to unlock <b>free shipping</b>.');
      $msgSavings.hide();
      $wrap.attr('data-shipping-false', '');
    }
  }

  var updating = false;
  function changeLineQuantity(line, quantity) {
    if (updating) return;
    updating = true;
    return $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: { line: line, quantity: quantity }
    }).always(function () { updating = false; })
      .done(function () { refreshCartUI(true); });
  }

  function ajaxAddToCart($form) {
    if (updating) return;
    updating = true;
    return $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: $form.serialize()
    }).always(function () { updating = false; })
      .done(function () { refreshCartUI(true); openDrawer(); })
      .fail(function (xhr) {
        try {
          var resp = xhr.responseJSON || JSON.parse(xhr.responseText);
          alert(resp && resp.description ? resp.description : 'Unable to add to cart.');
        } catch (e) { alert('Unable to add to cart.'); }
      });
  }

  $doc.on('click', '.site-header__cart, .site-header-cart-mobile', function (e) {
    e.preventDefault();
    openDrawer();
    fetchCartJSON().done(function (cart) {
      updateFreeShippingUI(cart);
      updateSubtotal(cart);
    });
  });

  $doc.on('click', '#side-cart .cross', function (e) { e.preventDefault(); closeDrawer(); });

  // Быстрое добавление рекомендованного товара по клику на .add_icon
  $(document).on('click', '#side-cart .add_icon', function (e) {
    e.preventDefault();
    var vid = $(this).attr('variant-id');
    if (!vid) return;

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: { id: vid, quantity: 1 }
    })
    .done(function () { refreshCartUI(true); })
    .fail(function (xhr) {
      try {
        var r = xhr.responseJSON || JSON.parse(xhr.responseText);
        alert(r && r.description ? r.description : 'Unable to add item.');
      } catch (_) { alert('Unable to add item.'); }
    });
  });

  $doc.on('mousedown.cartdrawer touchstart.cartdrawer', function (e) {
    var $drawer = $('#side-cart');
    if (!$drawer.hasClass('show-cart__drawer')) return;
    if ($(e.target).closest('#side-cart').length === 0) closeDrawer();
  });

  $doc.on('submit', 'form[action*="/cart/add"]', function (e) { e.preventDefault(); ajaxAddToCart($(this)); });

  // +/- кнопки количества
  $doc.on('click', '#side-cart .plus, #side-cart .minus', function (e) {
    e.preventDefault();
    var $item = $(this).closest('.cart__drawer-item');
    var line = parseInt($item.data('line'), 10);
    var $qtyInput = $item.find('input[name^="updates["]');
    var current = parseInt($qtyInput.val(), 10) || 0;
    var next = $(this).hasClass('plus') ? current + 1 : Math.max(0, current - 1);
    if (next === current) return;
    $qtyInput.val(next);
    changeLineQuantity(line, next);
  });

  // Удаление позиции
  $doc.on('click', '#side-cart .remove', function (e) {
    e.preventDefault();
    var line = parseInt($(this).closest('.cart__drawer-item').data('line'), 10);
    changeLineQuantity(line, 0);
  });

  // =======================
  // РУЧНОЙ ВВОД КОЛИЧЕСТВА
  // =======================
  var qtySelector = '#side-cart .cart__drawer-item input[name^="updates["]';

  function normalizeQty(val) {
    var n = parseInt(val, 10);
    if (isNaN(n) || n < 0) n = 0;
    return n;
  }

  // debounce обновления при вводе
  $doc.on('input', qtySelector, function () {
    var $input = $(this);
    var raw = ($input.val() || '').trim();

    if (raw === '') {
      var t0 = $input.data('debTO');
      if (t0) clearTimeout(t0);
      return;
    }

    var qty = normalizeQty(raw);

    var to = $input.data('debTO');
    if (to) clearTimeout(to);

    $input.data('debTO', setTimeout(function () {
      var $item = $input.closest('.cart__drawer-item');
      var line = parseInt($item.data('line'), 10);
      $input.val(qty);
      changeLineQuantity(line, qty);
    }, 500));
  });

  // мгновенное обновление по blur
  $doc.on('blur', qtySelector, function () {
    var $input = $(this);
    var to = $input.data('debTO');
    if (to) clearTimeout(to);

    var qty = normalizeQty(($input.val() || '').trim());
    $input.val(qty);

    var $item = $input.closest('.cart__drawer-item');
    var line = parseInt($item.data('line'), 10);
    changeLineQuantity(line, qty);
  });

  // Enter — не сабмитим форму, обновляем количество
  $doc.on('keydown', qtySelector, function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      $(this).blur(); // blur вызовет немедленное обновление
    }
  });
  // =======================

  $(function () { initAddonsSwiper(); });



  // ===== Public API (call from other files) =====
window.SideCart = window.SideCart || {};

window.SideCart.open = function () {
  openDrawer();
  fetchCartJSON().done(function (cart) {
    updateFreeShippingUI(cart);
    updateSubtotal(cart);
  });
};

window.SideCart.refresh = function (keepOpen) {
  return refreshCartUI(!!keepOpen);
};

window.SideCart.refreshAndOpen = function () {
  return refreshCartUI(true).always(function () {
    openDrawer();
  });
};



})(jQuery);
